module.exports = __webpack_public_path__ + "media/packs/images/flags/DK-c1e639db1a410d33d57fb467f76c0528.svg";